// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2kikz","row":"styles_row__2ZqYQ"};